import * as React from 'react'

import { decodeQueryString, encodeQueryString } from '../../queryString'
import { getCookie } from '../../shared/cookie'

interface Props {
  index: number
  isPremium: boolean
  isScreener: boolean
}

export function MenuLinks({ index, isPremium, isScreener }: Props) {
  const { b, t, ty, ta, p = 'd' } = decodeQueryString()
  const isUrlBack = !!b && Number.parseInt(b) > 0
  const isBackToScreenerUrl = isUrlBack && Number.parseInt(b) === 1
  const cookie = isUrlBack
    ? decodeURIComponent(getCookie(isBackToScreenerUrl ? 'screenerUrl' : 'insiderTradingUrl'))
    : null
  const backToLink =
    isScreener && isUrlBack && cookie ? (
      <a href={cookie} className="tab-link">
        back to {isBackToScreenerUrl ? 'screener' : 'insider'}
      </a>
    ) : null
  const urlTickers = t.split(',')
  const hasMoreTickers = !!t && urlTickers.length > 1
  const openInScreener =
    isScreener && hasMoreTickers ? (
      <a href={`screener.ashx?t=${urlTickers}`} className="tab-link">
        open in screener
      </a>
    ) : null
  const publishChartLinkButton =
    ty !== 'p' ? (
      <a
        href=""
        onClick={(event) => {
          event.preventDefault()
        }}
        className="tab-link js-publish-chart"
        data-index={index}
        data-ticker={urlTickers[index]}
        data-timeframe={p}
      >
        publish chart
      </a>
    ) : null
  const saveToPortfolioLink = (
    <a href={`/save_to_portfolio.ashx?t=${urlTickers[index]}`} className="tab-link">
      save to portfolio
    </a>
  )
  const createAlertLink = (
    <a
      href={
        isPremium
          ? `/create_alert.ashx?t=${urlTickers[index]}`
          : '/elite.ashx?utm_source=finviz&utm_medium=banner&utm_campaign=quote-create-alert'
      }
      className="tab-link"
    >
      create alert
    </a>
  )
  const backToChartLink =
    isPremium && ty === 'p' ? (
      <a href={`quote.ashx?${encodeQueryString({ b, t, ty: 'c', ta, p })}`} className="tab-link">
        <b>back to chart</b>
      </a>
    ) : (
      <a
        href={
          isPremium
            ? `quote.ashx?${encodeQueryString({ t, ty: 'p', ta: '0', p: 'd', tas: '0' })}`
            : `/elite.ashx?${encodeQueryString({
                utm_source: 'finviz',
                utm_medium: 'banner',
                utm_campaign: 'quote-compare-perf',
              })}`
        }
        className="tab-link"
        data-testid="quote-compare-perf-link"
      >
        compare perf.
      </a>
    )

  const links = [
    backToLink,
    openInScreener,
    publishChartLinkButton,
    saveToPortfolioLink,
    createAlertLink,
    backToChartLink,
  ].filter(Boolean)

  return (
    <div className="fullview-links mr-2 flex">
      {links.map((link, index) => (
        <React.Fragment key={index.toString()}>
          {index > 0 ? <span className="mx-1">|</span> : null}
          <div>{link}</div>
        </React.Fragment>
      ))}
    </div>
  )
}
